module.exports = __webpack_public_path__ + "img/portrait-063.e4570f98.jpg";